export default "__VITE_ASSET__10a37fa7__"